import axios from "axios";
import { connect } from "react-redux";
import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import DeployModal from "../DeployModal";
import EasyEdit, { Types } from "react-easy-edit";
import useAlertMessage from "../../hooks/useAlertMessage";
import { API_URL, API_V7_URL } from "../../constants/Globals";
import { Col, Row, Tab, Tabs, Table, Form } from "react-bootstrap";
import DeployDebate from "./DeployDebate";
import { ClientJS } from "clientjs";
import ReactFlowCollectionBranches from "./collections/AddEditCollection";
import {
  addNewSequence,
  updateSequenceById,
  updateIsDraftById,
} from "../../services/CollectionsSvc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import DeployCollection from "./DeployCollection";

const client = new ClientJS();

const fingerprint = client.getFingerprint();

function NewCollection({ selNetworkId, match }) {
  const [collectionName, setCollectionName] = useState("");
  const [embedCode, setEmbedCode] = useState("");
  const [isDraft, setIsDraft] = useState("");
  const [showDeployModal, setShowDeployModal] = useState(false);
  const [activeTab, setActiveTab] = useState("collection-details");
  const [setAlertMessage, getAlertMessage] = useAlertMessage();
  const { params } = match;

  const [currentDebateData, setCurrentDebateData] = useState({});
  const [dataTable, setDataTable] = useState({
    headers: [],
    rows: [],
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (params?.id !== "new") fetchCurrentDebate();
  }, [params.id]);

  const fetchCurrentDebate = async () => {
    await axios
      .get(
        API_URL +
          "/collections/" +
          params.id +
          "?deviceId=" +
          fingerprint +
          "&emailEmbedDebateLink=true"
      )
      .then((res) => {
        setCurrentDebateData(res.data.data);
      })
      .catch((err) => {
        alert("Failed. Please try again!");

        console.log(err);
      });
  };

  const history = useHistory();
  useEffect(() => {
    if (params.id === "new") {
      setEmbedCode("");
      setCollectionName("");
      setIsDraft(0);
    } else {
      axios.get(`${API_URL}/collections/${params.id}`).then(({ data }) => {
        const { name, isDraft } = data.data;
        setCollectionName(name);
        setIsDraft(isDraft);
      });
      setEmbedCode(
        `<div class="sided-widget" sequenceId="${params.id}"></div>`
      );
    }
  }, [params.id]);

  const search = window.location.search;

  const fetchSequenceDetails = async (pageNumber = 1) => {
    try {
      setIsLoading(true); // Set loading state
      const response = await axios.get(
        `${API_V7_URL}/api/sequences/${params.id}/completions?pageNumber=${pageNumber}&pageSize=10`
      );

      const { headers, rows, totalUsers, perPage } = response.data.data;
      const totalPages = Math.ceil(totalUsers / perPage);

      setDataTable({
        headers,
        rows,
      });
      setTotalPages(totalPages);
      setCurrentPage(pageNumber);
    } catch (error) {
      console.error("Failed to fetch sequence completions:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (params.id !== "new") {
      fetchSequenceDetails();
    }
  }, [params.id]);

  const handlePageChange = (pageNumber) => {
    fetchSequenceDetails(pageNumber);
  };

  const onSaveName = async (value) => {
    try {
      const data = {
        clientId: selNetworkId,
        name: value,
      };
      const response =
        params.id === "new"
          ? await addNewSequence(data)
          : await updateSequenceById(params.id, data);
      if (response.data.status) {
        if (params.id === "new") {
          history.push(`/sequences/${response.data.data}`);
        }
      }
    } catch (error) {}
  };

  const onSaveIsDraft = async (value) => {
    try {
      console.log(value.nameInputVal);
      const data = {
        clientId: selNetworkId,
        isDraft: value.isDraftInputVal,
      };
      const response = await updateIsDraftById(params.id, data);
      if (response.data.status) {
        setIsDraft(value.isDraftInputVal);
      }
    } catch (error) {}
  };

  const action = new URLSearchParams(search).get("action");

  const exportCSV = () => {
    const csvContent =
      "data:text/csv;charset=utf-8," +
      [dataTable.headers.join(",")]
        .concat(
          dataTable.rows.map((row) =>
            dataTable.headers.map((header) => row[header] || "-").join(",")
          )
        )
        .join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "completions_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section>
      {getAlertMessage()}

      <div className="table-filters">
        <Link to="/sequences" className="text-button">
          <svg
            width="9"
            height="14"
            viewBox="0 0 9 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.56 11.8135L6.68 13.6668L0 7.00016L6.68 0.333496L8.56 2.18683L3.81333 7.00016L8.56 11.8135Z"
              fill="#2F80ED"
            />
          </svg>
          All Sequences
        </Link>
      </div>

      <h1 className="page-title">
        {params.id === "new"
          ? "Add New Sequence"
          : `Edit Sequence: ${collectionName}`}
      </h1>
      <Tabs
        defaultActiveKey={"collection-details"}
        activeKey={activeTab}
        id="uncontrolled-tab-example"
        className="mt-4 mb-3 CreateDebateTabs pe-3 col-md-7"
        onSelect={(e) => setActiveTab(e)}
      >
        <Tab eventKey="collection-details" title="Sequence Details">
          <div className="segment-form after-tabs">
            <div className="segment-form-body padding-s">
              <div className="d-flex flex-row justify-content-between">
                {embedCode ? (
                  <div className="segment-form-field mb-l">
                    <label className="type-2">Sequence Embed Code</label>
                    <span
                      className="customBtn btn btn-secondary p-2 ps-4 pe-4"
                      onClick={({ target }) => {
                        const textArea =
                          target.parentElement.querySelector("textarea");
                        textArea.select();
                        document.execCommand("copy");
                        setAlertMessage("Embed code copied to clipboard!");
                      }}
                    >
                      Copy Code
                    </span>
                    <textarea
                      className="hiddenElement"
                      value={embedCode}
                      readOnly={true}
                    />
                  </div>
                ) : null}
                {params.id != "new" && (
                  <div className="d-flex flex-row">
                    <Form>
                      <Form.Group controlId="authorVerified">
                        <Form.Check.Label
                          style={{
                            fontWeight: "bold",
                            fontSize: "14px",
                            marginTop: "5px",
                          }}
                        >
                          {!(isDraft == 1) ? "Active" : "Inactive"}
                        </Form.Check.Label>
                        <Form.Check.Input
                          className="toggle-checkbox"
                          value="1"
                          defaultChecked={false}
                          onChange={(e) =>
                            onSaveIsDraft({
                              isDraftInputVal: e.target.checked ? 0 : 1,
                            })
                          }
                          name="isDraft"
                          checked={isDraft == 0}
                        />
                      </Form.Group>
                    </Form>
                    {/* <small
                      className="text-muted"
                      style={{
                        marginTop: "4px",
                        marginLeft: "5px",
                      }}
                    >
                      {isDraft == 1 ? "(Active)" : "(inactive)"}
                    </small> */}
                  </div>
                )}
              </div>
              <div className="segment-form-field mb-l">
                <label className="type-2">Sequence Name</label>
                <EasyEdit
                  type={Types.TEXT}
                  value={collectionName}
                  onSave={onSaveName}
                  saveButtonLabel={<FontAwesomeIcon icon={faCheck} />}
                  cancelButtonLabel={<FontAwesomeIcon icon={faTimes} />}
                  attributes={{ name: "collection-input", id: 1 }}
                />
              </div>

              {params.id !== "new" && (
                <ReactFlowCollectionBranches sequenceId={params.id} />
              )}
            </div>
          </div>
        </Tab>
        <Tab
          disabled={params.id === "new"}
          eventKey="deploy-collection"
          title="Deploy Sequence"
        >
          {params.id !== "new" && (
            <Row id="publish-debate-section" className="">
              <Col md={7} className="pe-3">
                <span className="lightColorSpan">
                  Deploy this sequence to your website by selecting page(s)
                  below and clicking "Deploy to Selected" then selecting the
                  appropriate "Placement". You can also "Deploy to All Pages" or
                  "Deploy to Category".
                </span>
                {currentDebateData?.name && (
                  <DeployCollection
                    isQuiz="false"
                    id="deploy-debate"
                    section="collection"
                    clientIdFromParent={selNetworkId}
                    debateIdFromParent={params.id}
                    actionFromParent={action}
                    currentDebateData={currentDebateData}
                  />
                )}
              </Col>
            </Row>
          )}
        </Tab>
        <Tab
          disabled={params.id === "new"}
          eventKey="completions"
          title="Completions"
        >
          <div className="segment-form after-tabs">
            <div className="segment-form-body padding-s">
              <button className="btn btn-secondary mb-3" onClick={exportCSV}>
                Export CSV
              </button>
              {isLoading ? (
                <p>Loading...</p>
              ) : (
                <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        {dataTable.headers &&
                          dataTable.headers.map((header, index) => (
                            <th key={index}>{header}</th>
                          ))}
                      </tr>
                    </thead>
                    <tbody>
                      {dataTable.rows && dataTable.rows.length > 0 ? (
                        dataTable.rows.map((row, rowIndex) => (
                          <tr key={rowIndex}>
                            {dataTable.headers.map((header, colIndex) => (
                              <td key={colIndex}>
                                {String(row[header] || "-")
                                  .split("\n")
                                  .map((line, i) => (
                                    <React.Fragment key={i}>
                                      {line}
                                      <br />
                                    </React.Fragment>
                                  ))}
                              </td>
                            ))}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={dataTable.headers.length}
                            className="text-center"
                          >
                            No logged in entries yet
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              )}
              <div className="pagination mt-4">
                <button
                  className="btn btn-primary"
                  disabled={currentPage === 1}
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </button>
                <span className="mx-2">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  className="btn btn-primary"
                  disabled={currentPage === totalPages || totalPages === 0}
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </Tab>
      </Tabs>

      {showDeployModal ? (
        <DeployModal onClose={() => setShowDeployModal(false)} />
      ) : null}
    </section>
  );
}

const mapStateToProps = (state) => ({
  selNetworkId: state.networks.selNetworkId,
});

export default connect(mapStateToProps)(NewCollection);
